import { render, staticRenderFns } from "./MarkdownViewer.vue?vue&type=template&id=124801a6&scoped=true"
import script from "./MarkdownViewer.vue?vue&type=script&lang=js"
export * from "./MarkdownViewer.vue?vue&type=script&lang=js"
import style0 from "./MarkdownViewer.vue?vue&type=style&index=0&id=124801a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124801a6",
  null
  
)

export default component.exports